module.exports = __webpack_public_path__ + "img/9788958283942.de6c45a9.jpg";